/**
 * Backend rejected the `?country=` code (422) — the FE country list is ahead
 * of the backend `CountryCode` enum.
 *
 * Lives in its own dependency-free module so error UIs can `instanceof` it
 * without importing the query hook's full dependency chain (flags → PostHog →
 * jotai), which matters for component tests that mock the hook module.
 */
export class SpecialtyCountryUnsupportedError extends Error {
  /** ISO code the backend rejected — lets error UIs name the country. */
  readonly country: string;

  constructor(country: string) {
    super(`/specialties rejected country "${country}" (422)`);
    this.name = 'SpecialtyCountryUnsupportedError';
    this.country = country;
  }
}
